import { recipe } from "@vanilla-extract/recipes";

import { transition } from "../../utils/transition";

export const activeOptionStyle = recipe({
  base: {
    userSelect: "none",
  },
  variants: {},
});

export const iconStyle = recipe({
  base: {
    transition: transition("transform"),
  },
  variants: {
    isOpen: {
      true: {
        transform: "rotate(-180deg)",
      },
    },
  },
});
